module.exports = __webpack_public_path__ + "static/riderlink_card-3c175e14cc787820b9290c8c5ca68340.png";